// extracted by mini-css-extract-plugin
module.exports = {"container":"_2uhgngjBnqdsEpl2RZ3bym","cancelBtn":"sYAGTkmC9Ae2UhGFpXNGJ","icon":"_1YTs43ZbNOaF4FDCP_GRMv","saveBtn":"_28tGqRSf7PPF-EVGbh3Pdw"};